import React, { useRef, useState } from 'react';
import { FiEdit2, FiKey } from 'react-icons/fi';
import useUpdatePermission from 'api/RoleResource/useUpdatePermission';
import { hasDistinctLabel, permissionTitle } from '../permissionUtils';

export default function EditPermission({ permissionId, permissionLabel, permissionName }) {
    const [editing, setEditing] = useState(false);
    const [label, setLabel] = useState(permissionLabel || '');
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);
    const savingRef = useRef(false);
    const triggerRef = useRef(null);
    const { mutateAsync, isLoading } = useUpdatePermission(permissionId);
    const busy = saving || isLoading;
    const errorId = `permission-label-error-${permissionId}`;
    const finish = () => {
        setEditing(false);
        requestAnimationFrame(() => triggerRef.current?.focus());
    };
    const save = async (event) => {
        event.preventDefault();
        if (savingRef.current) return;
        if (!label.trim()) { setError('Enter a permission label.'); return; }
        savingRef.current = true;
        setSaving(true);
        setError('');
        try {
            await mutateAsync({ label: label.trim() });
            finish();
        } catch {
            setError('Unable to save this label. Please try again.');
        } finally {
            savingRef.current = false;
            setSaving(false);
        }
    };

    return <div className={`access-permission-row${editing ? ' is-editing' : ''}`}>
        <span className="access-directory-icon"><FiKey aria-hidden="true" /></span>
        {editing ? <form className="access-label-form" onSubmit={save} aria-label={`Edit label for ${permissionName}`} aria-busy={busy}>
            <label htmlFor={`permission-label-${permissionId}`}>Display label <code>{permissionName}</code></label>
            <div className="access-label-fields"><input autoFocus id={`permission-label-${permissionId}`} type="text" value={label} disabled={busy} aria-invalid={!!error} aria-describedby={error ? errorId : undefined}
                onChange={(event) => setLabel(event.target.value)} onKeyDown={(event) => { if (event.key === 'Escape' && !busy) { event.preventDefault(); finish(); } }} />
                <button type="submit" className="portal-button portal-button-primary" disabled={busy}>{busy ? 'Saving…' : 'Save label'}</button><button type="button" className="portal-button" disabled={busy} onClick={finish}>Cancel</button></div>
            {error && <p id={errorId} className="access-form-error" role="alert">{error}</p>}
        </form> : <><div className="access-permission-copy"><strong>{permissionTitle({ name: permissionName, label: permissionLabel })}</strong>{hasDistinctLabel({ name: permissionName, label: permissionLabel }) && <code>{permissionName}</code>}</div>
            <button type="button" ref={triggerRef} className="access-label-edit" aria-label={`Edit label for ${permissionName}`} onClick={() => { setLabel(permissionLabel || ''); setError(''); setEditing(true); }}><FiEdit2 aria-hidden="true" /><span>Edit label</span></button></>}
    </div>;
}
